import { FC } from 'react';
import { MessageDescriptor, useIntl } from 'react-intl';
import { noop } from 'lodash';
import { createBemBlockBuilder } from '@ebsco-ui/ebsco-ui';

import { SortByDropdownWithIcon } from '@app/components';
import { wrapBoldTranslationChunks } from '@app/utils';
import { SortOption } from '@app/constants';

import './ResultCountWithSorting.scss';

interface ResultCountWithSortingProps {
  recordsCount: number;
  countMessage: MessageDescriptor;
  sortOptions: SortOption[];
  sortDirection: string;
  sortField?: string;
  onSortChange?: (option: SortOption) => void;
}

const cnBem = createBemBlockBuilder(['resultCountWithSorting']);

export const ResultCountWithSorting: FC<ResultCountWithSortingProps> = ({
  recordsCount,
  countMessage,
  sortOptions,
  sortField,
  sortDirection,
  onSortChange = noop,
}) => {
  const { $t } = useIntl();

  return (
    <div className={cnBem('__wrapper')}>
      <span className={cnBem('__resultsCount')} data-auto="results-count">
        {$t(countMessage, {
          count: recordsCount,
          b: wrapBoldTranslationChunks,
        })}
      </span>
      {recordsCount > 0 && (
        <SortByDropdownWithIcon
          sortField={sortField}
          sortDirection={sortDirection}
          options={sortOptions}
          onSelect={onSortChange}
        />
      )}
    </div>
  );
};
